import React from "react";

import ReactDOM from "react-dom";
import "core-js/stable";
import GaussValidators from "@dvrt/gauss-validators-javascript";

import HeimdallValidators from "./heimdall-validators";

import descriptors from "./descriptors";

import HeimdallContext from "./HeimdallContext";

import App from "./components/App";
import ValidatorRegistry from "./utils/ValidatorRegistry";

function startApp() {
    const schemas = window.schemas;
    for (const [resourceName, descriptor] of Object.entries(descriptors)) {
        const schema = schemas.resources[resourceName];
        if (descriptor.resourceSchemaPostProcessor) {
            descriptor.resourceSchemaPostProcessor(schema);
        }
    }

    if (window.features.ldap) {
        descriptors["ldap_auth"].enumTranslation = {
            directory_type: (data: string) => {
                return "ldap_auth.directory_types." + data;
            },
        };
    } else {
        delete descriptors["ldap_auth"];
    }

    for (const descriptor of ["managed_user", "simplified_user", "user"]) {
        descriptors[descriptor].enumTranslation = {
            gender: (data: string) => {
                return "user." + data;
            },
        };
    }

    // initialize validators
    const validators = Object.assign({}, HeimdallValidators, GaussValidators);
    const validatorRegistry = new ValidatorRegistry();
    for (const name in validators) validatorRegistry.add(validators[name]);

    // Create the heimdallContext
    const heimdallContext = new HeimdallContext(window.identityProvider, validatorRegistry);
    ReactDOM.render(<App context={heimdallContext} />, document.getElementById("root"));
}

// In production environment we just do not request (the non-existent) sourcemap.
startApp();
